import { ChangeDetectionStrategy, Component, OnDestroy } from '@angular/core';

import { RemoteDiagnosticsSnapshotsStore, SnapshotType } from '@store';

@Component({
  selector: 'app-snapshot',
  templateUrl: './snapshot.component.html',
  styleUrls: ['./snapshot.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SnapshotComponent implements OnDestroy {
  readonly snapshotType = SnapshotType;

  constructor(public remoteDiagnosticsSnapshotsStore: RemoteDiagnosticsSnapshotsStore) {}

  ngOnDestroy(): void {
    this.remoteDiagnosticsSnapshotsStore.selectSnapshot(null);
    this.remoteDiagnosticsSnapshotsStore.setInstallationVddList([]);
    this.remoteDiagnosticsSnapshotsStore.clearDateOfTheValuesRead();
    this.remoteDiagnosticsSnapshotsStore.hideValues();
  }
}
